module.exports = __webpack_public_path__ + "static/KarenVilla-d1682f303569a7bb5830fd7a095f6c27.png";